/**
 * The invite link tagged with the inviter's language, so the landing page
 * opens in it. String-built: Hermes' `URL` has no writable `searchParams`.
 */
export function linkWithLanguage(link: string, language: string): string {
  const [base, query = ''] = link.split('?');
  const kept = query
    .split('&')
    .filter(pair => pair && !pair.startsWith('lang='));
  return `${base}?${[...kept, `lang=${encodeURIComponent(language)}`].join('&')}`;
}
